// Shared descriptions shown in the info-icon tooltips next to dashboard chart headings.

export const BRANCH_SALES_GRAPH_DESCRIPTION =
  'Monthly paid sales for the current calendar year. Each bar is the total of paid invoices ' +
  '(both invoice systems, non-reimbursable fees) counted in the month they were paid. The dashed ' +
  'line is the monthly target (yearly goal ÷ 12); the % on each bar is that month’s sales vs ' +
  'that target. The banner above shows year-to-date sales against the full yearly target.';

export const BRANCH_INCOME_CHART_DESCRIPTION =
  'This calendar month’s income for the selected branches (all branches by default). “Sales” is ' +
  'the total of paid invoices this month — both invoice systems, non-reimbursable fees only; ' +
  '“Projected Sales” is the monthly target (combined yearly goal ÷ 12). The “% Achieved” in the ' +
  'centre is this month’s sales against that target.';

// Used by both the Branch Admin "Monthly Proposal Graph" and the Employee "Monthly Sales Report".
export const PROPOSAL_GRAPH_DESCRIPTION =
  'Proposals created vs approved, by month, for the current calendar year. One bar is all ' +
  'proposals created that month (any status); the other is the subset currently in “Approved” ' +
  'status. Hover a bar for the matching dollar amount and proposal count. Note: a proposal’s ' +
  'dollar amount isn’t always recorded, so the $ totals can run below the actual proposal count.';

export const MONTHLY_INCOME_CHART_DESCRIPTION =
  'Your monthly paid sales vs your branch’s, for the current calendar year. “My Sales” = paid ' +
  'invoices for permits you manage; “Office Sales” = your branch’s total paid invoices; ' +
  '“Target Sales” = the monthly target (branch yearly goal ÷ 12) — all counted in the month each ' +
  'invoice was paid. The banner above shows the branch’s year-to-date sales against the full ' +
  'yearly target, plus your share of it.';
